/**
 * NativeSubscriptionSurface — single entry point for subscription UI inside
 * the native apps.
 *
 *  - Native iOS + IAP_APPLE_ENABLED → real StoreKit purchase surface.
 *  - Any other native case (Android, iOS with the flag off) → the neutral
 *    NativePremiumMessage, unchanged.
 *  - Web is untouched (callers only render this behind a native check).
 */
import { useIsNativeIOS, NativePremiumMessage } from "@/hooks/useIsNativeIOS";
import { IOSPricingPlanSelector } from "@/components/IOSPricingPlanSelector";
import { isAppleIapEnabled } from "@/lib/iap/feature-flag";

interface NativeSubscriptionSurfaceProps {
  language: string;
}

export function NativeSubscriptionSurface({ language }: NativeSubscriptionSurfaceProps) {
  const isNativeIOS = useIsNativeIOS();

  if (isNativeIOS && isAppleIapEnabled()) {
    return <IOSPricingPlanSelector />;
  }

  return <NativePremiumMessage language={language} />;
}

export default NativeSubscriptionSurface;
